var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLevelLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75.537,
    height: 80.074,
    viewBox: "0 0 75.537 80.074",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_6896",
    x: 1.823,
    y: 0,
    width: 71.976,
    height: 78.922,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.451
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.026,
    y1: 0.5,
    x2: 0,
    y2: 0.446,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#113e7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b2275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_6898",
    x: 10.381,
    y: 9.042,
    width: 54.857,
    height: 60.838,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.31
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    x2: 1.001,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#113e7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#021761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2c4a84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#304cb2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_6901",
    x: 52.631,
    y: 60.514,
    width: 22.907,
    height: 19.56,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.412
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_6904",
    x: 0,
    y: 60.514,
    width: 22.906,
    height: 19.56,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.412
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "basic-1",
    transform: "translate(1.5 2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1.5, -2)",
    filter: "url(#Path_6896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6896-2",
    "data-name": "Path 6896",
    d: "M39.781.726Q46.623,4.089,53.231,7.9t12.953,8.052A6.7,6.7,0,0,1,69.219,21.2c.325,4.769.516,9.9.516,15.262s-.172,10.474-.516,15.264a6.7,6.7,0,0,1-3.034,5.247q-6.335,4.249-12.953,8.05-6.6,3.813-13.452,7.174a6.7,6.7,0,0,1-6.065,0q-6.843-3.364-13.452-7.174T7.307,56.971a6.7,6.7,0,0,1-3.032-5.247Q3.759,44.1,3.759,36.461c0-5.36.172-10.473.516-15.262a6.7,6.7,0,0,1,3.032-5.247c3.968-2.672,8.319-5.381,12.955-8.052q6.6-3.813,13.452-7.174a6.7,6.7,0,0,1,6.065,0Z",
    transform: "translate(1.06 2)",
    fill: "#6d80c4",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6897",
    "data-name": "Path 6897",
    d: "M38.548,1.163a5.094,5.094,0,0,0-4.636,0Q26.977,4.549,20.29,8.412,13.6,12.257,7.181,16.542a5.056,5.056,0,0,0-2.328,4.005q-.516,7.679-.516,15.379c0,5.132.153,10.265.516,15.377a5.056,5.056,0,0,0,2.328,4.005q6.41,4.292,13.108,8.128t13.622,7.251a5.094,5.094,0,0,0,4.636,0Q45.483,67.3,52.17,63.437q6.687-3.844,13.106-8.128A5.058,5.058,0,0,0,67.6,51.3q.516-7.669.516-15.379c0-5.131-.153-10.263-.516-15.375a5.054,5.054,0,0,0-2.328-4.007Q58.868,12.25,52.17,8.414T38.548,1.163Z",
    transform: "translate(0.079 0.538)",
    fill: "#6d80c4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1.5, -2)",
    filter: "url(#Path_6898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6898-2",
    "data-name": "Path 6898",
    d: "M31.877,61.453q-5.794-2.938-11.447-6.144Q14.8,52.123,9.421,48.517a3.357,3.357,0,0,1-1.544-2.672,218.959,218.959,0,0,1,0-25.871A3.357,3.357,0,0,1,9.421,17.3q5.4-3.567,11.009-6.792,5.633-3.237,11.447-6.142a3.359,3.359,0,0,1,3.091,0q5.725,2.9,11.447,6.144Q52.046,13.7,57.424,17.3a3.359,3.359,0,0,1,1.545,2.672,219.01,219.01,0,0,1,0,25.871,3.359,3.359,0,0,1-1.547,2.672q-5.4,3.567-11.007,6.792-5.634,3.238-11.449,6.144a3.357,3.357,0,0,1-3.089,0Z",
    transform: "translate(4.39 5.55)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6899",
    "data-name": "Path 6899",
    d: "M31.635,5.157q-5.66,2.789-11.1,5.989T9.788,17.768a2.1,2.1,0,0,0-.992,1.7q-.382,6.3-.363,12.611T8.8,44.69a2.1,2.1,0,0,0,.992,1.7q5.269,3.474,10.743,6.62T31.635,59a2.1,2.1,0,0,0,1.908,0q5.66-2.789,11.1-5.989t10.741-6.622a2.1,2.1,0,0,0,.992-1.7q.383-6.3.363-12.611t-.363-12.611a2.1,2.1,0,0,0-.992-1.7q-5.268-3.474-10.741-6.62t-11.1-5.989a2.1,2.1,0,0,0-1.908,0Z",
    transform: "translate(3.721 4.384)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6900",
    "data-name": "Path 6900",
    d: "M33.628,22.822v4.34a17.372,17.372,0,0,1-.6,4.874,8.871,8.871,0,0,1-1.738,3.34,6.866,6.866,0,0,1-2.67,1.912,9.2,9.2,0,0,1-3.444.62,10.117,10.117,0,0,1-2.825-.378,7.112,7.112,0,0,1-2.358-1.224A7.767,7.767,0,0,1,18.2,34.222a10.661,10.661,0,0,1-1.137-3.031,18.389,18.389,0,0,1-.4-4.03v-4.34a16.976,16.976,0,0,1,.6-4.837,9,9,0,0,1,1.738-3.325,6.845,6.845,0,0,1,2.687-1.9,9.2,9.2,0,0,1,3.444-.62,9.522,9.522,0,0,1,2.808.4A6.883,6.883,0,0,1,32.1,15.814a10.4,10.4,0,0,1,1.137,3.013,18.05,18.05,0,0,1,.4,3.994Zm-4.977,5V22.149a15.85,15.85,0,0,0-.155-2.375,6.972,6.972,0,0,0-.431-1.721,3.637,3.637,0,0,0-.722-1.171,2.636,2.636,0,0,0-.982-.656,3.457,3.457,0,0,0-1.222-.206,3.306,3.306,0,0,0-1.5.327,2.792,2.792,0,0,0-1.084,1.05,5.672,5.672,0,0,0-.69,1.9,15.515,15.515,0,0,0-.223,2.859v5.666a18.155,18.155,0,0,0,.138,2.392,8.136,8.136,0,0,0,.446,1.776,4.422,4.422,0,0,0,.724,1.187,2.636,2.636,0,0,0,.982.656,3.6,3.6,0,0,0,1.239.206,3.172,3.172,0,0,0,1.464-.327,2.9,2.9,0,0,0,1.1-1.067,5.582,5.582,0,0,0,.69-1.929A15.94,15.94,0,0,0,28.652,27.817Z",
    transform: "translate(11.043 10.801)",
    fill: "#ffd046"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1.5, -2)",
    filter: "url(#Path_6901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6901-2",
    "data-name": "Path 6901",
    d: "M49.745,35.718c-1.43-.172-10.628-1.508-10.628-3.682a1.107,1.107,0,0,1,.421-.8A27.263,27.263,0,0,0,30.3,40.277a2.154,2.154,0,0,0-.363,1.908,2.37,2.37,0,0,0,1.145,1.3A42.62,42.62,0,0,0,42.875,47.8a21.716,21.716,0,0,0,.5-7,13.108,13.108,0,0,0,6.392-5l-.019-.076Z",
    transform: "translate(24.27 29.78)",
    fill: "#6d80c4",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6902",
    "data-name": "Path 6902",
    d: "M31.2,39.891c.555,2.175,8.511,4.311,11.7,5.075a4.262,4.262,0,0,1-.17,1.183c-2.862-.667-11.676-3.032-12.345-5.341a2.061,2.061,0,0,1,.363-1.738l.839-.818a1.906,1.906,0,0,0-.382,1.64Zm16.39-2.462c-2.5-.4-10.416-1.908-10.55-3.949a1.281,1.281,0,0,1,.419-.992l.839-.82a1.185,1.185,0,0,0-.419.9c0,2.137,8.719,3.569,10.665,3.816a12.932,12.932,0,0,1-.954,1.03v.019Z",
    transform: "translate(23.191 28.165)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6903",
    "data-name": "Path 6903",
    d: "M35.13,41.5c-1.2.822-5.553-.648-5.19,1.564A2.158,2.158,0,0,1,30.3,41.16,39.226,39.226,0,0,1,41.254,30.134a1.1,1.1,0,0,0-.419.8c0,.629.744,1.183,1.908,1.621A39.737,39.737,0,0,1,35.11,41.41l.019.094Z",
    transform: "translate(22.774 26.8)",
    fill: "#ded7dd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1.5, -2)",
    filter: "url(#Path_6904)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6904-2",
    "data-name": "Path 6904",
    d: "M2.019,35.718c1.43-.172,10.628-1.508,10.628-3.682a1.107,1.107,0,0,0-.419-.8,27.263,27.263,0,0,1,9.233,9.04,2.16,2.16,0,0,1,.363,1.908,2.365,2.365,0,0,1-1.145,1.3A42.623,42.623,0,0,1,8.889,47.8a21.75,21.75,0,0,1-.5-7,13.108,13.108,0,0,1-6.392-5l.019-.076Z",
    transform: "translate(-0.5 29.78)",
    fill: "#6d80c4",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6905",
    "data-name": "Path 6905",
    d: "M19.8,39.891c-.554,2.175-8.51,4.311-11.7,5.075a4.262,4.262,0,0,0,.17,1.183c2.864-.667,11.676-3.032,12.345-5.341a2.059,2.059,0,0,0-.361-1.738l-.841-.818a1.908,1.908,0,0,1,.382,1.64ZM3.469,37.43c2.5-.4,10.418-1.908,10.55-3.949a1.279,1.279,0,0,0-.419-.992l-.839-.82a1.185,1.185,0,0,1,.419.9c0,2.137-8.719,3.569-10.665,3.816a12.931,12.931,0,0,0,.954,1.03v.019Z",
    transform: "translate(-1.542 28.165)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6906",
    "data-name": "Path 6906",
    d: "M13.379,41.5c1.2.822,5.553-.648,5.19,1.564a2.158,2.158,0,0,0-.363-1.908A39.225,39.225,0,0,0,7.256,30.134a1.105,1.105,0,0,1,.419.8c0,.629-.744,1.183-1.908,1.621A39.738,39.738,0,0,0,13.4,41.41l-.019.094Z",
    transform: "translate(1.35 26.8)",
    fill: "#ded7dd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6907",
    "data-name": "Path 6907",
    d: "M39.01,27.659c-.782,1.258-3.816,6.352-4.712,7.516s-.973,1.583-2.9,1.719-6.008.265-7.631.283c-.744,0-1.392-.283-1.336-1.143s.782-.86,1.355-.879c1.47,0,4.9-.189,6.545-.3a5.747,5.747,0,0,0,1.678-.249,4.769,4.769,0,0,0,1.47-1.374c.839-.954,3.816-5.494,4.5-6.333s1.564,0,1.069.763h-.038Z",
    transform: "translate(16.167 23.609)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6908",
    "data-name": "Path 6908",
    d: "M21.276,25.217a84.943,84.943,0,0,1,16.371,1.468c2.69.554,13.184,3.263,14.251,5.914a2.118,2.118,0,0,1,0,1.7,32.051,32.051,0,0,1-9,11.6c1.355-1.107.285-2.785-.954-3.6a23.046,23.046,0,0,0-8.109-2.709,70.942,70.942,0,0,0-12.555-1.05q-.167-3.5-.17-7,0-3.339.17-6.3Z",
    transform: "translate(14.992 22.425)",
    fill: "#6d80c4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6909",
    "data-name": "Path 6909",
    d: "M35.7,25.217a84.943,84.943,0,0,0-16.371,1.468c-2.689.554-13.182,3.263-14.251,5.914a2.118,2.118,0,0,0,0,1.7,32.051,32.051,0,0,0,9,11.6c-1.355-1.107-.285-2.785.954-3.6a23.046,23.046,0,0,1,8.109-2.709A70.942,70.942,0,0,1,35.7,38.533q.17-3.662.17-7t-.17-6.3Z",
    transform: "translate(0.575 22.425)",
    fill: "#6d80c4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6910",
    "data-name": "Path 6910",
    d: "M13.252,39.636a3.014,3.014,0,0,0-1.508,3.682l.591.572a3.376,3.376,0,0,1,1.738-3.206,25.38,25.38,0,0,1,8.583-2.9,72,72,0,0,1,12.955-1.105V35.4a72.487,72.487,0,0,0-13.354,1.164A27.735,27.735,0,0,0,13.2,39.617l.057.019Zm-7.44-4.313A3.471,3.471,0,0,1,7.72,32.614a45.794,45.794,0,0,1,12.249-4.141,78.984,78.984,0,0,1,15.682-1.506V25.821a79.919,79.919,0,0,0-16.025,1.545A48.69,48.69,0,0,0,6.938,31.659,3.815,3.815,0,0,0,5.03,33.872l.189.382.593,1.069Z",
    transform: "translate(0.695 22.964)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6911",
    "data-name": "Path 6911",
    d: "M33.607,25.731a79.008,79.008,0,0,0-14.461,1.3,52.954,52.954,0,0,0-11.9,3.588,54.908,54.908,0,0,1,11.924-3.473,81.244,81.244,0,0,1,14.442-1.26v-.151ZM13.746,38.477A40.067,40.067,0,0,1,22.352,36.3a75.3,75.3,0,0,1,11.236-.8,60.339,60.339,0,0,0-11.276.7,37.957,37.957,0,0,0-8.566,2.271Z",
    transform: "translate(2.661 22.884)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6912",
    "data-name": "Path 6912",
    d: "M14.9,39.592a47.685,47.685,0,0,1-4.559-5.725,33.48,33.48,0,0,1-3.129-5.723,8.006,8.006,0,0,0-1.776,1.222l-.246.285a1.908,1.908,0,0,0,0,.325,31.039,31.039,0,0,0,3.28,5.589,28.954,28.954,0,0,0,4.941,5.592A4.162,4.162,0,0,1,14.695,39.8l.21-.208Z",
    transform: "translate(0.836 25.03)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6913",
    "data-name": "Path 6913",
    d: "M43.617,39.635a3.014,3.014,0,0,1,1.506,3.682l-.591.572A3.376,3.376,0,0,0,42.8,40.684a25.39,25.39,0,0,0-8.585-2.9,72,72,0,0,0-12.955-1.105V35.4a72.646,72.646,0,0,1,13.358,1.164,27.75,27.75,0,0,1,9.061,3.053l-.057.019Zm7.44-4.311a3.471,3.471,0,0,0-1.91-2.709A45.794,45.794,0,0,0,36.9,28.473a78.983,78.983,0,0,0-15.682-1.506V25.822a79.8,79.8,0,0,1,16.025,1.545,48.692,48.692,0,0,1,12.687,4.293,3.816,3.816,0,0,1,1.908,2.212l-.191.382-.591,1.069Z",
    transform: "translate(15.09 22.965)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6914",
    "data-name": "Path 6914",
    d: "M21.2,25.731a79.137,79.137,0,0,1,14.461,1.3,52.954,52.954,0,0,1,11.907,3.588,54.908,54.908,0,0,0-11.926-3.473A81.241,81.241,0,0,0,21.2,25.884v-.151ZM41.058,38.477a40.067,40.067,0,0,0-8.6-2.175,75.487,75.487,0,0,0-11.238-.8,60.339,60.339,0,0,1,11.276.7A37.961,37.961,0,0,1,41.058,38.477Z",
    transform: "translate(15.073 22.884)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6915",
    "data-name": "Path 6915",
    d: "M32.123,39.592a47.86,47.86,0,0,0,4.559-5.725,33.47,33.47,0,0,0,3.129-5.723,8.05,8.05,0,0,1,1.776,1.222l.246.285a1.865,1.865,0,0,1,0,.325,31.029,31.029,0,0,1-3.28,5.589,28.824,28.824,0,0,1-4.943,5.592A4.139,4.139,0,0,0,32.333,39.8l-.21-.208Z",
    transform: "translate(24.79 25.03)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevelLogo);
export default __webpack_public_path__ + "static/media/level-logo.90441f8b1958c03c889444759244236e.svg";
export { ForwardRef as ReactComponent };